import React from 'react';
import SiteHeader from './../../../components/SiteHeader';
import UserAutoCompleteInput from '../../../components/UserAutoCompleteInput';

const ChatHeader = ({ handleSearchChatUser }) => {
    const centerContent = (
        <div className="w-full">
            <div className="p-inputgroup">
                <span className="p-inputgroup-addon">
                    <i className="pi pi-search"></i>
                </span>
                <UserAutoCompleteInput 
                    handleSearchUser={handleSearchChatUser} 
                />
            </div>
        </div>
    );

    return <SiteHeader centerContent={centerContent} />;
};

export default ChatHeader;
